<template>
  <div class="dealer-register-container">
    <div class="dealer-register-form">
      <el-form @submit.native.prevent="submitForm" :model="form" :rules="rules" ref="dealerForm">
        <h2>Регистрация дилера</h2>

        <el-form-item prop="name">
          <el-input v-model="form.name" placeholder="Название компании"></el-input>
        </el-form-item>

        <el-form-item prop="address">
          <el-input
            v-model="form.address"
            type="textarea"
            :rows="3"
            placeholder="Адрес"
          ></el-input>
        </el-form-item>

        <el-form-item prop="logo">
          <el-upload
            class="logo-uploader"
            action=""
            :auto-upload="false"
            :show-file-list="false"
            :on-change="handleLogoChange"
            accept="image/*"
          >
            <img v-if="logoPreview" :src="logoPreview" class="logo-preview" />
            <i v-else class="el-icon-plus logo-uploader-icon"></i>
          </el-upload>
          <div class="upload-hint">Загрузить логотип</div>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            native-type="submit"
            :loading="loading"
            :disabled="loading"
          >
            Зарегистрировать
          </el-button>
        </el-form-item>

        <div v-if="successMessage" class="success-message">
          {{ successMessage }}
          <div v-if="dealerUrl" class="slug-info">
            Ваша ссылка: <a :href="dealerUrl" target="_blank">{{ dealerUrl }}</a>
          </div>
        </div>

        <div class="form-footer">
          <router-link to="/dealers-admin" class="dealers-link">
            Список всех дилеров →
          </router-link>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "DealerRegister",
  data() {
    return {
      form: {
        name: "",
        address: "",
        logo: null,
      },
      logoPreview: null,
      loading: false,
      successMessage: "",
      dealerUrl: "",
      rules: {
        name: [
          { required: true, message: "Введите название компании", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    handleLogoChange(file) {
      this.form.logo = file.raw;
      this.logoPreview = URL.createObjectURL(file.raw);
    },
    async submitForm() {
      this.$refs.dealerForm.validate(async (valid) => {
        if (!valid) return;

        this.loading = true;
        this.successMessage = "";
        this.dealerUrl = "";

        const formData = new FormData();
        formData.append("name", this.form.name);
        formData.append("address", this.form.address);
        if (this.form.logo) {
          formData.append("logo", this.form.logo);
        }

        try {
          const response = await axios.post(
            "https://forklifts.kz/api-crm/dealers/create/",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );

          this.successMessage = "Дилер успешно зарегистрирован!";
          this.dealerUrl = response.data.dealer_url;

          // Сброс формы
          this.form.name = "";
          this.form.address = "";
          this.form.logo = null;
          this.logoPreview = null;

          this.$notify.success({
            title: "Успех",
            message: "Дилер успешно зарегистрирован",
          });
        } catch (error) {
          console.error("Ошибка при регистрации дилера:", error);
          const errorMessage =
            error.response?.data?.name?.[0] ||
            error.response?.data?.detail ||
            "Ошибка при регистрации дилера";

          this.$notify.error({
            title: "Ошибка",
            message: errorMessage,
          });
        } finally {
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.dealer-register-container {
  width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
}

.dealer-register-form {
  width: 100%;
  max-width: 500px;
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

  h2 {
    text-align: center;
    margin-bottom: 30px;
    color: #303133;
  }
}

.el-form-item {
  margin-bottom: 20px;
}

.el-button {
  width: 100%;
}

.logo-uploader {
  display: flex;
  justify-content: center;

  :deep(.el-upload) {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 150px;
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      border-color: #409eff;
    }
  }
}

.logo-uploader-icon {
  font-size: 28px;
  color: #8c939d;
}

.logo-preview {
  width: 150px;
  height: 150px;
  object-fit: contain;
}

.upload-hint {
  text-align: center;
  font-size: 12px;
  color: #909399;
  margin-top: 8px;
}

.success-message {
  text-align: center;
  color: #67c23a;
  margin-top: 20px;
  padding: 15px;
  background: #f0f9eb;
  border-radius: 4px;

  .slug-info {
    margin-top: 10px;
    color: #606266;

    a {
      color: #409eff;
      text-decoration: none;
      font-weight: 600;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.form-footer {
  margin-top: 20px;
  text-align: center;
}

.dealers-link {
  color: #409eff;
  text-decoration: none;
  font-size: 14px;

  &:hover {
    text-decoration: underline;
  }
}
</style>
